import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=180e3256&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180e3256')) {
      api.createRecord('180e3256', component.options)
    } else {
      api.reload('180e3256', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=180e3256&", function () {
      api.rerender('180e3256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W1rIKmDdBh3Z/JS/offershelp.vue"
export default component.exports